module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAA9klEQVR4nO2ZsQkCQRQFH7KWYGAdWqA9mNmIVZjYgqhwLRhocHIccqZ/xJuBDe4nf25go01quSZ5TpxdscfAglr8KxiAFqAxAC1AYwBagMYAtACNAWgBGgPQAjQGoAVoDEAL0BiAFqAxAC1AYwBagMYAtACNAWgBmpZkU7hv+WW+LvToklzGg6nHyn8++/HPz/4KGIAWoDEALUDTkmwL9x2TrCbmh/epoBt/tCSnosVJ8vgyvxd7DMz+ChiAFqAxAC1AYwBagMYAtACNAWgBGgPQAjQGoAVoDEAL0BiAFqAxAC1AYwBagKYV7zunfwP45FbsISI9L1ZMTsBgeoxpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus/PNG-plus-black.png
// module id = 95
// module chunks = 0